import { render, staticRenderFns } from "./Conceptospagobyunidad.vue?vue&type=template&id=769be7f0"
import script from "./Conceptospagobyunidad.vue?vue&type=script&lang=js"
export * from "./Conceptospagobyunidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports